// Localization is based on '@ngx-translate/core';
// Please be familiar with official documentations first => https://github.com/ngx-translate/core

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface Locale {
  lang: string;
  data: any;
}

export interface ILanguageTranslation {
  code: string;
  text: string;
}

const LOCALIZATION_LOCAL_STORAGE_KEY = 'language';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  // Private properties
  private langIds: any = [];
  private defaultLanguage = 'en';
  private availableLangs: Array<ILanguageTranslation> = [
    { code: 'en', text: 'English' },
    { code: 'es', text: 'Spanish' }
  ];

  constructor(private translate: TranslateService) {
    // add new langIds to the list
    this.translate.addLangs(this.availableLangs.map((lang: ILanguageTranslation) => lang.code));

    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang(this.defaultLanguage);
  }

  loadTranslations(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach((locale) => {
      // use setTranslation() with the third argument set to true
      // to append translations instead of replacing them
      this.translate.setTranslation(locale.lang, locale.data, true);
      this.langIds.push(locale.lang);
    });

    // add new languages to the list
    this.translate.addLangs(this.langIds);
    this.translate.use(this.getSelectedLanguage());
  }

  setLanguage(lang: string) {
    if (lang) {
      this.translate.use(this.translate.getDefaultLang());
      this.translate.use(lang);
      localStorage.setItem(LOCALIZATION_LOCAL_STORAGE_KEY, lang);
    }
  }

  /**
   * Returns selected language
   */
  getSelectedLanguage(): any {
    return (
      localStorage.getItem(LOCALIZATION_LOCAL_STORAGE_KEY) ||
      this.translate.getDefaultLang()
    );
  }

  getLocale() {
    if (this.translate.currentLang === 'es') {
      return 'es_LA';
    } else {
      if (this.translate.currentLang === 'en') {
        return 'en_US';
      } else {
        if (this.translate.currentLang === 'fr') {
          return 'fr_CA';
        }
      }
    }
    return 'es_LA';
  }

  getAvailableLanguages(): Array<ILanguageTranslation> {
    return this.availableLangs;
  }
}
